import React, { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import { Formik } from "formik";
import { isNil } from "ramda";

import { InnerFormContext } from "../../controls/innerFormContext";
import { ValueRecord } from "../../types";

export const FormView: React.FC<React.PropsWithChildren> = ({ children }) => {
  const formContext = useContext(InnerFormContext);
  if (isNil(formContext)) return <></>;

  const { initialData, formData, validate, validationSchema, confirmData: handleSubmit } = formContext;
  const initialValues = formData ?? initialData ?? {};

  return (
    <Routes>
      <Route
        index
        element={
          <Formik<ValueRecord | Record<string, never>>
            enableReinitialize
            initialValues={initialValues ?? {}}
            onSubmit={handleSubmit}
            validate={validate}
            validationSchema={validationSchema}
            validateOnBlur={false}
            validateOnChange={false}
          >
            {children}
          </Formik>
        }
      />
    </Routes>
  );
};
